export default {
    "common": {
        "Failed": "fail",
        "Succeed": "success"
    },
    "login": {
        "notAlloweLogin": "Login prohibited!",
        "password": "Please input password",
        "noUserInformation": "There is no user information for the time being. Please try logout and login again.",
        "login_first": "Please login first!",
        "Login": "Login",
        "passwordWrong": "Account or password is wrong",
        "title": " IOT SYSTEM",
        "userName": "Please input account",
        "loginTimeoutPleaseLogin": "Please login first.",
        "logOut": "Log Out",
        "visitorLogIn": "Guest login",
        "noLoginPleaseLoginFirst": "Please login first."
    },
    "basicinfo": {
        "OutOfSettingArea": "Out of setting area",
        "TotalCharged": "Total Charged",
        "Idled": "Idle",
        "AbnormalTemperature": "Faulty temperature",
        "LowVoltage": "Low voltage",
        "SinceLastReset": "Since Last Reset",
        "paramCannotbeEmpty": "Parameter cannot be empty",
        "Charged": "Charged",
        "submitChange": "submit change?",
        "Idle": "Idle",
        "Voltage": "Voltage",
        "CellVoltage": "Cell Voltage",
        "Charging": "Charging",
        "DisCharged": "Discharged",
        "HighVoltage": "High voltage",
        "SOHBad": "SOH Bad",
        "LowLevel": "Low level",
        "DCSYSTEM": "DC SYSTEM",
        "FirmwareVersion": "Firmware Version",
        "DisCharging": "Discharging",
        "lowPower": "Low power",
        "SystemVoltage": "System Voltage",
        "LowTemperature": "Low temperature",
        "ACOUTPUT": "AC OUTPUT",
        "HighTemperature": "High temperature",
        "ACINPUT": "AC INPUT",
        "BindingTime": "Setup Time",
        "TotalDischarged": "Total Discharged"
    },
    "button": {
        "ConfirmSubmit": "Confirm to submit?",
        "Downloading": "Downloading, please wait patiently......",
        "Reminder": "Reminder",
        "select": "Please select",
        "Cancel": "Cancel",
        "Back": "Back",
        "ConfirmDelete": "confirm to delete?",
        "Confirm": "Confirm",
        "Submit": "Submit",
        "Close": "Close",
        "NoUpdateTime": "No update time"
    },
    "dashboard": {
        "TotalDevices": "Total devices (units)",
        "Undefined": "(Undefined)",
        "Set": "Set",
        "SiteName": "Site name",
        "AllDevices": "All Devices",
        "Normal": "Normal",
        "RecentNotices": "Recent Warnings",
        "Details": "Details",
        "SiteView": "Site overview",
        "Total": "Total",
        "OwnerView": "Owner overview",
        "TotalWarnDevice": "Total devices with warning (units)",
        "LatestUpdate": "Latest Update",
        "Abnormal": "Abnormal",
        "DeviceName": "Device Name"
    },
    "AllDevices": {
        "ConfirmReset": "Confirm reset ID?",
        "Delete": "Delete",
        "SetZero": "Set zero",
        "BondDevice": "Bond Device",
        "DefaultSort": "Default sort",
        "SetChanged1": "Settings changed at",
        "SetSOC": "Set SOC",
        "Calibrate": "Calibrate",
        "endDate": "end date",
        "companyName": "company name",
        "CurrentSOC": "Current SOC",
        "NumberOfConnected": "Number of connected",
        "UpdateFailed": "Update failed. Please contact us.",
        "StartNetOnce": "Start the network once a day",
        "GPS": "Positioning",
        "sureDelete": "Are you sure you want to delete the device record?",
        "cellNumber": "Number of cell",
        "BatteryMonitor": "Battery Monitor",
        "ChargeCurrent": "Charge current",
        "updateIndex": "updateIndex is used to upload a segmentof records, from this value to the most recent cycle number.",
        "VSampChange": "Voltage sampling rate of change",
        "DeleteRecord": "Delete device record",
        "GraphicDescription": "Graphical Description",
        "IgnitionReport": "Show ignition",
        "submitP": "Submitted!Device will be updated after online.",
        "FullyTurnOnGPS": "Fully turn on GPS",
        "HighVVersion": "High voltage version",
        "TurnOffGPS": "Turn off GPS completely",
        "CalibZero": "Calibration value reset",
        "deleteDetail": "All data and settings will be deleted, make sure you know what you are doing!",
        "ActiveDevices": "Active devices",
        "Ascending": "Ascending",
        "mustInt": "Must be an integer",
        "IgnitionVoltage": "Ignition on threshold voltage",
        "CurrentSet": "Current settings",
        "LithiumBattery": "Lithium Battery",
        "Status": "Status",
        "UseVoltageTh": "Hourmeter on threshold voltage",
        "DischargeCurrent": "Discharge current",
        "DeleteAllData": "Delete all data",
        "FullyOpenNet": "Fully open the network",
        "StartNet2h": "Start the network every 2h",
        "connectivityHealth": "Connectivity health",
        "abnormal": "abnormal",
        "charger": "Charger",
        "RelayStatus": "Relay status",
        "GPSFunction": "GPS function",
        "HardwareV": "Hardware voltage level",
        "mustBetween": "The value of $1 must be between $2",
        "Close": "Close",
        "ReverseOrder": "Reverse order",
        "waitUpdate": "Settings waiting for update",
        "Realtimedata": "Realtime Data",
        "Current": "Current",
        "SetChanged2": ". Waiting ack from device.",
        "VCalibZero": "Are you sure to clear the voltage calibration value to zero?",
        "ConfirmSetZero": "Confirm set zero?",
        "startDate": "start date",
        "SearchDeviceNameOrSn": "Search device name/serial number",
        "wait": "Update time maybe last for minutes, please wait patiently",
        "ResendID": "Resend ID",
        "enableUnbind": "Are you sure to enable the unbind function?",
        "HalfV": "Half voltage",
        "DynamicSamp": "Dynamic sampling",
        "Open": "Open",
        "NonHighVVersion": "Non-high voltage version",
        "StartGPS2h": "Start GPS every 2h",
        "SearchDeviceSn": "Search device serial number",
        "intOrThreeDecimal": "can only be an integer or up to three decimal places",
        "connectivityHealthInfo": "In the last 15 days, the statistical probability of 24h intranet for all devices",
        "working": "working",
        "sampPeriod": "The sampling period",
        "hadBindWarn": "$ has been bound, binding again will replace the previous data, please determine whether to continue the operation",
        "enterCorrectsn": "Please enter the correct sn.",
        "downCanDataCheckDate": "Please select the start and end date of the data",
        "connectivityHealth2": "Connectivity health",
        "normal": "normal",
        "NumberOfDevices": "Number of devices",
        "ConfirmDelete": "Confirm delete all data?",
        "SelectType": "Select Type",
        "NetFeatures": "Network features",
        "Controller": "Controller",
        "InstallationTime": "Installation Time",
        "View": "View",
        "hallCalibZero": "Are you sure to clear the HALL calibration value to zero?",
        "NoNetworkInfo": "No network information, please contact us",
        "SampAlgorithm": "Sampling algorithm",
        "Type": "Type",
        "TheCurrentState": "The current or last state of the device",
        "untie": "Are you sure to unbind?",
        "shuntCalibZero": "Are you sure to clear the SHUNT calibration value to zero?",
        "secondVol": "Secondary voltage",
        "to": "to",
        "StaticSampling": "Static sampling"
    },
    "BondOrUpdateDevice": {
        "InvalidBatteryModel": "Invalid battery model",
        "LEDIndicator": "LED indicator",
        "SecondsTimes": "Seconds / times",
        "Reverse": "Reverse",
        "MCUID": "MCUID",
        "EquipmentType": "Equipment type",
        "Name": "Name",
        "Capacity": "Capacity",
        "fullChargeTime": "Full charge time",
        "PleaseEnterSN": "Please enter the SN",
        "PleaseEnterAName": "Please enter a name",
        "RemoteControl": "Remote control",
        "FindSN": "Find the SN on the device sticker",
        "communication": "RS485 communication",
        "Failed": "Failed",
        "EditInfo": "Edit Info",
        "SelectBattery": "Select battery",
        "IncorrectPasscode": "Incorrect passcode",
        "OwnedCompany": "Owned Company",
        "Advanced": "Advance",
        "Passcode": "Passcode",
        "BondSucceed": "Succeed!",
        "ResetBindingTime": "Reset binding time, only for battery replacement",
        "Yes": "Yes",
        "enterNumScope": "Please enter a value between $1-$2",
        "Machine": "Machine",
        "Off": "Off",
        "AuxVolAcquisition": "Aux voltage acquisition",
        "BondedAlready": "Bonded already",
        "enterNumOver": "Please enter an integer not less than $1",
        "NodeID": "Node ID",
        "SetFrequency": "Set frequency",
        "SN": "SN",
        "EnterNumbers": "Enter passcode(PC)",
        "No": "No",
        "SensorType": "Sensor type",
        "FindPC": "Find the PC on the device sticker",
        "PleaseSelectOperatingVoltage": "Please select the operating voltage",
        "EditSucceed": "Succeed!",
        "canopenBaudrate": "Baud rate",
        "BatteryInformation": "Battery",
        "SNNotFound": "SN not found",
        "currentCollection": "Aux current acquisition",
        "EnterBatteryCapacity": "Please enter the battery capacity(Ah)",
        "LevelSensor": "Level sensor",
        "Model": "Model",
        "Forward": "Forward",
        "Submit": "Submit",
        "InvalidDeviceInfo": "Invalid device info",
        "Track": "Track",
        "On": "On"
    },
    "warningInfo": {
        "has_expired": "Data Service has expired",
        "offlineWarn": "The device is offline for more than $1 hour, please check the network",
        "batterySocLow1": "SOC is as low as",
        "your": "your",
        "batterySocLow2": "%, please charge.",
        "periodic_vehicles": "Vehicle Periodic Maintenance",
        "linChargeOverWarn": "The current temporary charge is too many times and needs to be fully charged to maintain battery health",
        "maintained": "serviced",
        "batteryVoltageHeight2": "V, please check battery or charger.",
        "batteryVoltageHeight1": "Voltage is higher than",
        "overTiemTo": "The data service is valid until $1. In order not to affect the use, please renew it in time.",
        "linChargeOver": "overcharge",
        "data_until": "Data Service Valid Until",
        "willbe_maintained": "Will be serviced at $1",
        "HalfVWarn": "Half voltage imbalance,please check battery.",
        "unitVLow": "low monomer voltage",
        "AlarmDuration": "Alarm duration",
        "batteryTemHeight1": "Temperature has reached",
        "batteryTemHeight2": ", please cool down before use.",
        "batteryCapacity1": "The capacity should be",
        "batteryCapacity2": "Ah, Low SOH, please check Battery replacement.",
        "batteryNoWarning": "All devices have no warning at the moment.",
        "has_expired_desc": "The data service has expired, the device has been deactivated, please contact the operator if you need to continue using it",
        "batteryTemAbnormal": "Abnormal temperature,please check sensor.",
        "battery_not_used": "Battery has not been used for a long time",
        "deferred": "Go to pay deferral",
        "maint_tips": "Maintenance Tips",
        "maint_text2": "Please do maintenance to ensure that the equipment is functioning properly.",
        "batteryWaterLow": "Low water level, please refill.",
        "secondVolLow1": "Secondary voltage lower than",
        "secondVolLow2": "V, please check the battery!",
        "maint_text": "The set maintenance conditions have been met, please perform maintenance to ensure proper operation of the equipment.",
        "secondVolLow": "Secondary voltage too low",
        "dataService": "Data Service",
        "periodic_maint": "Periodic maintenance",
        "WorkStatus": "Working status",
        "LevelWarn1": "(Level 1 warning)",
        "LevelWarn2": "(Level 2 warning)",
        "overTiem": "The data service has expired, please renew it in time so as not to affect the usage.",
        "ignore": "ignore, don't prompt again",
        "LevelWarn3": "(Level 3 warning)",
        "batteryTemLow1": "Temperature is as low as",
        "LevelWarn4": "(Level 4 warning)",
        "batteryTemLow2": ", please warm up before use.",
        "batteryVoltageLow2": "V, please charge.",
        "batteryVoltageLow1": "Voltage is as low as",
        "renewal_reminder_desc": "The validity period of the data service is about to expire; When the device has not been paid for more than 30 days, the device becomes deactivated",
        "batteryNoPosition": "Out of bounds.",
        "HalfVWarnS": "Half voltage imbalance",
        "ignore_now": "Ignore for now",
        "battery_maint": "Battery Maintenance",
        "NetworkAbnormal": "Network abnormality",
        "renewal_reminder": "Data Service Renewal Reminder",
        "capacity_maint": "Capacity Maintenance",
        "unitVLowWarn": "monomer voltage too low"
    },
    "dataAndTime": {
        "Monday": "Mon",
        "Hours": "Hr.",
        "Mins": "Min.",
        "Hour": "Hr.",
        "ago": "ago",
        "NearlyDays7": "Pass 7 days",
        "AMomentAgo": "A Moment Ago",
        "Saturday": "Sat",
        "waitingUpdate": "waiting for update...",
        "Min": "Min.",
        "Second": "Second",
        "Thursday": "Thu",
        "Friday": "Fri",
        "Sunday": "Sun",
        "Days": "Days",
        "Wednesday": "Wed",
        "Yr": "Yr",
        "Seconds": "Seconds",
        "Tuesday": "Tue",
        "NearlyDays30": "Pass 30 days",
        "Yrs": "Yr",
        "Day": "Day"
    },
    "allDeviceDetail": {
        "LogRemark": "Log description",
        "TotalCharged": "Total Charged",
        "ActivationTime": "Activation date",
        "Connected": "Connected",
        "LowVoltage": "Low voltage",
        "OutSettingArea": "Out of setting area",
        "TotalChargeSinceInstallation": "Total charged and discharged since installation",
        "UpdateFailed": "Update failed. Please contact us.",
        "Attributes": "Attributes",
        "networking": "Networking",
        "good": "Good",
        "sohTips2": "Excellent: 90%-100%;Good: 70%-90%;Medium: 50%-70%;Poor: less than 50%, it is recommended to replace the battery",
        "sohTips1": "Battery health is counted by multiple groups of charge and discharge data. The more deep discharge and full charge times, the more accurate the data is.",
        "GiveMonth": "Waived months",
        "exFlow": "Excess traffic of the month",
        "LevelWarning": "Level warning",
        "NumberRestarts": "Number of restarts",
        "poor": "Poor",
        "resetFunction": "reset function",
        "highCurrent": "Ah available at high current",
        "IgnitionTime": "Ignition ON-Time",
        "noEligibleData": "The calculation is successful, but there are no eligible data for this calculation!",
        "Smoothsoc": "Smoothed soc",
        "NumberTimes": "Number of times",
        "DeviceLog": "Device log",
        "gpsonly": "GPS Only",
        "CellVoltageInfo": "Cell voltage = voltage of a single cell",
        "FirmwareVersiongo": "Firmware Version",
        "months": "months",
        "SocVolt": "SocVolt",
        "excellent": "Excellent",
        "Expiration": "Expiration date",
        "startEndTime": "Duration between start and end time must within 3 days.",
        "confirmReset": "confirm reset?",
        "statisticsCount": "Device reboot count statistics",
        "LowLevel": "Low level",
        "DCSYSTEM": "DC SYSTEM",
        "SOHaverage": "Average SOH",
        "SystemVoltage": "System Voltage",
        "ACOUTPUT": "AC OUTPUT",
        "month": "month",
        "NoLocationInfo": "No location information",
        "Value": "Value",
        "NotInstalled": "--",
        "resetSucceed": "reset succeed!",
        "ACINPUT": "AC INPUT",
        "BindingTime": "Setup Time",
        "ignoreCharg": "Whether to ignore charging",
        "TotalDischarged": "Total Discharged",
        "MonitoringDuration": "Monitored duration",
        "ReFlow": "Remaining traffic of the month",
        "no": "No",
        "AbnormalTemperature": "Faulty temperature",
        "KeySwitch": "Key switch",
        "Yes": "Yes",
        "CommunicationFailure": "Communication failure",
        "calcSuccess": "The calculation is successful!",
        "hardwareMalfunction": "Hardware malfunction",
        "RemainingTime": "Remaining available time",
        "cellNumberInfo": "Number of battery cells = number of cells connected in series in a battery",
        "dischargeA": "Current discharge current",
        "HourMeTime": "Hour Meter ON-Time",
        "saveDatabase": "Whether to save to database",
        "medium": "Medium",
        "Overdischarge": "Overdischarge",
        "Idle": "Idle",
        "realFlow": "Actual usage",
        "resetFailed": "reset failed!",
        "SocMidway": "Soc intermidiate value",
        "RenewalMonth": "Renewal month",
        "CalculateSOH": "Calculate SOH",
        "DeviceNameCannotEmpty": "Device name cannot be empty",
        "FinallyAH": "Final available AH",
        "findPC1": "find the PC on the",
        "Charging": "Charging",
        "HighVoltage": "High voltage",
        "findPC2": "device sticker",
        "Bad": "Low",
        "PackageFlow": "Package",
        "SOHBad": "SOH low",
        "Discharging": "Discharging",
        "HourMeter": "Hour Meter",
        "DeviceAnaInp": "Device Analog Input ",
        "NotConnected": "Not connected",
        "Normal": "Normal",
        "TheorySoc": "Soc in theory",
        "lowPower": "Low SOC",
        "startReset": "start reset",
        "LowTemperature": "Low temperature",
        "HighTemperature": "High temperature",
        "SocNotSmooth": "Soc is not smoothed",
        "Times": "Times",
        "UpdateTime": "Package update time",
        "time": "Time"
    },
    "yhubReport": {
        "EnergyDistribution": "Energy distribution",
        "MinTemp": "Min Temp",
        "endDate": "end date",
        "EnergyRatio": "Energy ratio",
        "MaxVoltage": "Max Voltage",
        "OtherInput": "Other Input",
        "Ignition": "Ignition",
        "LowestSOC": "Lowest SOC",
        "aWeek": "A week",
        "device_type": "Device Type",
        "Intermediate": "Intermediate",
        "UsageRate": "Utilization",
        "Capacity": "Capacity",
        "DischargeInfo": "Discharged=Total discharged AH between 2 charge cycles,therefore will be updated only after a charge.",
        "confirmCalculateChargeDischarge": "Are you sure to recalculate charge and discharge?",
        "day": "day",
        "Records": "Records",
        "AnalogInpStat": "Analog Input Statistic",
        "MinVoltage": "Min Voltage",
        "IDEL": "IDLE",
        "occurredAt": "Occurred at",
        "dischargeAH": "DISCHARGED AH",
        "ah": "AH",
        "index": "Cycle No",
        "Dailystatistics": "Daily statistics",
        "Duration": "Duration",
        "chargeDischargeRatio": "charge/discharge Ratio",
        "Operating": "Operation",
        "DCSYSTEM": "DC SYSTEM",
        "MaxTemp": "Max Temp",
        "StartTemp": "Starting temp",
        "usedDuration": "USED DURATION",
        "UseTime": "Machine used duration",
        "StartSOC": "Start SOC",
        "EndSOC": "End SOC",
        "chargeDuration": "CHARGED DURATION",
        "calculateChargeDischargeExceeded": "The recalculation time range cannot exceed 60 days",
        "BindingTime": "Binding Time",
        "ChargingTime": "Charging duration",
        "MonitoringDuration": "Monitored duration",
        "startDate": "start date",
        "UseComma": "Use comma \",\" as decimal separator :",
        "chargeAH": "CHARGED AH",
        "MinimumSOC": "Min SOC",
        "WarningMessage": "Warning message",
        "EndTemp": "End temp",
        "EndTime": "End Time",
        "AnalogInput": "Analog input",
        "HighestTem": "Highest temperature",
        "DepthDischarge": "Depth of Discharge",
        "StartingTime": "Starting Time",
        "chargeAndDischargeRecords": "Charged and Discharged Records",
        "Charts": "Charts",
        "Machine": "Machine",
        "NoWarnings": "No warnings occurred in the selected time",
        "yesterday": "Yesterday",
        "runtime_duration": "Runtime duration",
        "Energy": "Energy (kWh)",
        "Hourmeter": "Hourmeter",
        "today": "today",
        "ChargedInfo": "Charged Info",
        "Ratio": "Ratio",
        "usage_duration": "Usage duration",
        "DischargedInfo": "Discharged Info",
        "HourCounter": "Hour counter",
        "aMonth": "A month",
        "Charge": "Charged",
        "UsedRate": "Utilization rate",
        "Date": "Date",
        "Discharge": "Discharged",
        "FirmwareVersion": "Firmware Version",
        "Nodata": "No data",
        "TotalAh": "Total Ah",
        "averageTemp": "Average temp",
        "ChargType": "Charging type",
        "WorkingHours": "Working hours",
        "WorkTime": "Daily work hour=from the first discharge event to the last discharge event within a day",
        "BatteryInformation": "Battery",
        "ChargeInfo": "Charge=Charge duration greater than 5 minutes",
        "usedTime": "Machine used duration=cumulative discharge duration within a day",
        "MaximumTemperature": "Max Temp.",
        "FullCharge": "Full charge",
        "AHDistribution": "AH distribution",
        "historyReport": "HISTORY REPORT",
        "InputHourmeter": "Input1(Hourmeter)",
        "MinimumVoltage": "Min voltage",
        "to": "to",
        "LowestVol": "Lowest voltage"
    },
    "warningPage": {
        "Remain": "Remain",
        "Unsolved": "Unsolved",
        "AddedToday": "Added today",
        "SOC": "SOC",
        "CreatedAt": "Happened",
        "SolvedToday": "Solved today",
        "SOH": "SOH",
        "Remark": "Remark",
        "Solevd": "Resolved",
        "Content": "Content",
        "SovledAt": "Sovled at",
        "Voltage": "Voltage",
        "temperature": "Temperature",
        "Level": "Level",
        "Geofence": "Position info"
    },
    "location": {
        "agdeleted": "deleted!",
        "latitude": "latitude",
        "delete": "delete",
        "delete2": "delete?",
        "enabled": "enabled!",
        "switched_map": "Switched to Sky Map for You",
        "trackReplay": "track replay",
        "endDateThanToday": "end date should greater than today!",
        "enable": "enable",
        "warning": "warning!your device is out of boundary",
        "disabled": "disabled!",
        "GPSWaring": "Please turn on positioning function before use.",
        "radius": "radius",
        "longitude": "longitude",
        "add": "add",
        "coordinate": "coordinate",
        "contiune": "contiune",
        "enableGeofencing": "enable geofencing?",
        "edit": "edit",
        "created": "created!",
        "meter": "meter",
        "start": "start",
        "Expired": "Expired,please edit the valid date",
        "createNew": "create new",
        "pause": "pause",
        "cancelEdit": "Cancel editing",
        "FenceSet": "Set fence",
        "pleaseSelectDate": "please select date",
        "GPSWaring1": "Please turn on positioning function before use.",
        "dragEditRadiu": "Drag edit radius",
        "NoLocationInfo": "No record information is found, please select another device or reset the start and end time.",
        "stop": "stop",
        "disableGeofencing": "disable geofencing?",
        "disable": "disable",
        "validTime": "valid time",
        "device": "device",
        "geofencing": "geofencing",
        "updated": "updated",
        "dragCenterToMoveAround": "drag center of existing boundary to move around"
    },
    "warningSet": {
        "warnPusher": "Warning message pusher",
        "chargeDisWarn": "Charge-discharge ratio warning",
        "OfflineTime2": "Warning value is greater than",
        "notSet": "not set",
        "volProtectSwitchOff": "Low voltage protection off",
        "charging_limit": "Temporary overcharging warning",
        "lowTemperature": "Low temperature",
        "dischargeCurrentSwitchOn": "Discharge overcurrent on",
        "periodic_vehicles": "Vehicle periodic maintenance",
        "highVal": "High value",
        "second": "s",
        "HighTemperature2": "Level 2 high temp.",
        "MaintMethod": "Maintenance method",
        "HighTemperature3": "Level 3 high temp.",
        "temError": "Temp. abnormal",
        "recoveryVoltage": "Recovery",
        "enable": "enable",
        "LevelWarning": "Level",
        "temWarn": "Temperature",
        "disableAll": "disable all",
        "options": "Options",
        "disableAllWarning": "disable all warning?",
        "openTotalWarn": "Total warnings need to be turned on to subscribe to messages",
        "chargeCurrentSwitchOff": "Charging overcurrent off",
        "recoverVal": "Recovery value",
        "voltageSwitchOff": "Voltage warning off",
        "dischargeCurrentSwitchOff": "Discharge overcurrent off",
        "StartCharge": "Start charging",
        "enterNumber": "Please enter a whole number or up to two decimal places",
        "hightVoltage": "High voltage",
        "warningSettings": "Warning settings",
        "infoPusher": "Message Pusher",
        "chargingOvercurrent": "Charging overcurrent",
        "dischargeOvercurrent": "Discharge overcurrent",
        "every_month_1": "every month",
        "every_month_2": "Day",
        "AlarmDuration": "Alarm duration",
        "contactList": "Message recipient",
        "lowVal": "Low value",
        "submitted": "submitted!",
        "underVoltage": "The under-voltage configuration must be less than the system voltage",
        "volProtectSwitchOn": "Low voltage protection on",
        "chargeDisAbnormal": "The charge-discharge ratio is abnormal",
        "chargeDisWarnVal": "Charge-discharge ratio warning threshold",
        "lowSocRecover": "low soc recover threshold(%)",
        "voltageSwitchOn": "Voltage warning on",
        "full": "battery full",
        "Pleaseenter": "Please enter",
        "parameterError": "Parameter error, please check",
        "lowSOCThreshold": "low SOC threshold(%)",
        "OfflineTime": "Network abnormality",
        "HalfV": "Half voltage",
        "times_greater": "Number of times",
        "subscribe_news": "Subscribe to news",
        "Succeed": "Succeed!",
        "duration": "duration",
        "current": "Current",
        "periodic_maint": "Periodic maintenance",
        "secondVLow": "The second way voltage is too low alarm",
        "lowVoltage": "Level 1 low voltage",
        "LowVoltageProtection": "Low voltage protection",
        "overVoltage": "The over-voltage configuration must be greater than the system voltage",
        "value": "Value",
        "HalfVThreshold": "Half voltage threshold",
        "socWarn": "SOC",
        "owner": "owner",
        "SubUsageInfo": "Subscribe usage message",
        "or": "or",
        "chargeCurrentSwitchOn": "Charging overcurrent on",
        "battery_maint": "Battery maintenance",
        "AlarmSwitch": "Alarm on/off",
        "per_charge_1": "per charge capacity",
        "Date": "Date",
        "DisCharging": "Discharging",
        "voltage": "Voltage",
        "capacity_maint": "Capacity maintenance",
        "chargeDisAbnormalWarn": "The charge-discharge ratio is abnormal, please use the battery reasonably",
        "HighTemperature": "Level 1 high temp.",
        "voltageProtectionSwitch": "Voltage protection switch",
        "disable": "disable",
        "voltageDuration": "Voltage duration",
        "abnormalV": "abnormal voltage",
        "lowVoltage3": "Level 3 low voltage",
        "lowVoltage2": "Level 2 low voltage"
    },
    "lease": {
        "no": "",
        "Customer": "Customer",
        "ExpireOn": "Expiration date",
        "Cannotbeblanked": "Cannot be blanked",
        "Income": "Income",
        "LeaseInformation": "Lease Information",
        "Maintenancerecord": "Maintenance record",
        "TotalIncome": "Total income",
        "Cannotbeblanked2": "Cannot be blanked",
        "Unlockmachine": "Unlock the machine?",
        "Reason": "Reason for lock",
        "TotalIncome2": "Total income",
        "EditRemot": "Edit here for remote cutoff",
        "Machinelocked": "Machine locked!",
        "Succeed": "Succeed!",
        "duration": "duration (day)",
        "Locked": "locked",
        "machineSN": "Machine SN",
        "LockedState": "Locked state",
        "Person2": "Person",
        "PleaseEnterSN": "Please enter machine SN",
        "NotLocked": "Not locked",
        "TotalRentedDays2": "Total rented days",
        "RentalRecords": "Rental records",
        "Enteramount": "Enter amount",
        "DeviceInformation": "Device Information",
        "Invalid": "Invalid",
        "deviceTo1": "\"All devices\"->\"Battery monitor\" -> ",
        "deviceTo2": " -> \"Edit configuration information\" -> \"Remote control\"",
        "amount": "amount",
        "Selectstartdate": "Select start date",
        "Startandenddate": "Start and end date",
        "Failed": "Failed!",
        "Unlock": "Unlock",
        "deleteDevice": "Are you sure to delete the device?",
        "Expired": "Expired",
        "deviceTo": "\"All devices\"->\"Battery monitor\"->\"Edit config icon\"->\"Advance\"->\"Remote control\"",
        "Machineunlocked": "Machine unlocked!",
        "Lock": "Lock",
        "Valid": "Valid",
        "Content": "Content",
        "RentedDays": "Rented days",
        "TotalRentedDays": "Total rented days",
        "SelectDate": "Select date",
        "Person": "Person"
    },
    "company": {
        "Account": "Account",
        "Email": "Email",
        "CompanyID": "Company ID",
        "BasicModule": "Basic module",
        "noPermission": "No operation rights, please contact the administrator!",
        "Numberofbranches": "Number of branches",
        "Deletechildcompanies": "Delete this company and its child companies?",
        "companyAccount": "Company's account",
        "LeaseMagt": "Lease management",
        "Name": "Name",
        "Deletethisaccount": "Delete this account?",
        "onlyNumLetter": "Can only contain letters, numbers and underscores",
        "Numberofaccounts": "Number of accounts",
        "enterNewPassAgain": "Please enter the new password again",
        "imgSize": "Only jpg/png/jpeg files can be uploaded, no more than $1, size $2",
        "Guest": "General user",
        "AccountMagt": "Account Management",
        "siteNameEn": "System name (English)",
        "childCompany": "Branch Company",
        "Companywebsite": "Company website",
        "Role": "Role",
        "webUrl": "domain name",
        "Companyaddress": "Company address",
        "DesktopMagt": "Desktop Management",
        "enterNewPass": "Please enter a new password",
        "backgroundImage": "background image",
        "enterRightPhone": "Please enter the correct phone number",
        "strLength": "The length is between $1~$2",
        "remark": "Problem Description",
        "Companyname": "Company name",
        "drmModule": "DRM system module",
        "editAccount": "Edit account",
        "Feedback": "Feedback",
        "enterLowercaseNum": "Please enter 1~20 lowercase letters or numbers",
        "deviceDis": "Equipment Distribution",
        "uploadImg": "Upload image",
        "DeviceMsg": "Device message",
        "Parentcompany": "Parent company",
        "company": "Company",
        "addAccount": "Add account",
        "Password": "Password",
        "NewPassword": "New password",
        "CustomConfig": "Customized configuration",
        "DuplicateAccountName": "Duplicate account name",
        "siteNameCn": "System name (Chinese)",
        "Mobile": "Mobile",
        "Deletecompanyinfo": "Delete company info?",
        "mustSame": "The password entered twice must be the same!",
        "notEnterChineseSpace": "Cannot enter Chinese and spaces",
        "AccountSettings": "Account Settings",
        "imgNameLen": "The length of the image name cannot exceed 100, please try again!",
        "notEnterSpaces": "Cannot enter spaces",
        "BranchStructure": "Branch structure"
    },
    "weekReportEmail": {
        "contactUs": "Company Detail",
        "downWeekReport": "Download PDF",
        "companyDetail": "Contact Us",
        "WeeklyReport": "Weekly Report"
    },
    "QR": {
        "BTS": "Batt.-Temp.",
        "FileName": "FileName",
        "PleaseNote": "Please note: This document should be named using the SN, otherwise it will not upload!",
        "Uploadtime": "Upload Time",
        "Profile": "curve",
        "dishargedAH": "Disharged AH",
        "lithium": "Lithium battery",
        "selectEvent": "Select Event",
        "warrantyperiod": "Warranty Date",
        "EndV": "End V",
        "EventRecords": "Event Records",
        "Records": "Records",
        "Uploader": "Upload person",
        "charge": "Charger",
        "ACVoltage": "AC Voltage",
        "Dateofmanufacture": "Manufactured Date",
        "ForExample": "For Example",
        "Salesordernumber": "PO",
        "StartV": "Start V",
        "StartTime": "Start Time",
        "contentError": "Content error!",
        "Duration": "Duration",
        "ProductID": "Model",
        "deviceSN": "Device SN",
        "Date": "Date",
        "SelectFile": "Select File",
        "ChargedAH": "Charged AH",
        "uploadFailed": "upload failed! Please fill in the correct document name!"
    },
    "lithiumQr": {
        "otherVal": "other",
        "chargeDischargePort1": "1 Public hole",
        "batteryMakeDate": "Battery make date",
        "chargeDischargePort2": "2 Independent hole",
        "ratedEnergy": "Rated energy",
        "auth": "Auth",
        "dischargeMethod": "Discharge method",
        "cycles": "Cycles",
        "coolingMethod": "Cooling method",
        "chargeWorkingTemperature": "Charge temperature",
        "communicationPort": "Communication port",
        "coolingMethod1": "1 Natural cooling",
        "bmsWeight": "Weight(KG)",
        "updateBy": "Update by",
        "batterySerialNumber": "Battery SN",
        "dischargeMethod1": "1 Constant current discharge",
        "storageTemperature": "Storage temperature",
        "batteryBrand": "Battery brand",
        "batteryCapacity": "Capacity(AH)",
        "sn": "BMS SN",
        "chargingMethod": "Charging method",
        "selfDischargeRate": "Self discharge rate",
        "chargeDischargePort": "Charge discharge port",
        "bmsInstallDate": "BMS install date",
        "updateTime": "Update time",
        "voltage": "Voltage(V)",
        "batteryModule": "Battery module",
        "bmsFirmwareVersion": "Firmware version",
        "bmsSize": "Size",
        "chargingMethod1": "1 Constant current and constant voltage",
        "storageHumidity": "Storage humidity",
        "bmsModule": "BMS module",
        "bmsPcbCode": "BMS pcb code",
        "dischargeWorkingTemperature": "Discharge temperature"
    },
    "lithiumWarn": {
        "ChargingTemTooHigh": "Charging temperature too high",
        "ChargingTotalVoltageOver": "Charging voltage too high",
        "DischargeTemHigh": "Discharge temperature too high",
        "ChargingTotalUnderV": "Undervoltage during charging",
        "RelayAdhesion": "Relay melted",
        "ChargerMalfunction": "Charger malfunction",
        "DischargeOvercurrent": "Discharging current too high",
        "ChargingOvervoltage": "Cell overvoltage during charging",
        "ChargingTemLow": "Charging temperature is too low",
        "ChargingUndervoltage": "Cell overvoltage during charging",
        "DangerVoltageProtect": "Dangerous voltage protection",
        "DischargeToalOverv": "Overvoltage during discharging",
        "ExcessiveDifference": "Voltage difference too large",
        "ComInterrupted": "Communication interrupted",
        "LowSOC": "Low SOC",
        "TotalDisVLow": "Voltage too low during discharging",
        "DischargeMonUnder": "Cell undervoltage during discharging",
        "ChargingTemTooLow": "Charging temperature too low",
        "DischargeTemLow": "Discharge temperature too low",
        "ChargeOvercurrent": "Charging current too high",
        "DischargeCellOverV": "Cell overvoltage during discharging",
        "InsulationTooLow": "Insulation is too low",
        "TemperatureLarge": "Temperature difference too large"
    },
    "socDetailPage": {
        "Note1": "Statistical power consumption: calculated by the battery monitor (Y-Hub), equal to the power consumption between two charges.",
        "DeleteLine": "Delete a line",
        "NominalCapacity": "Nominal Capacity(Ah)",
        "NoRecord": "No record found, please select another device or reset the start and end time.",
        "StartDrawingLine": "Start drawing a line",
        "PowerDifference": "Power Difference",
        "Note": "Note:",
        "Note8": "SOC power = (100-40)% * 225 = 135AH",
        "Note7": "Example: Nominal capacity=225AH, SOC=40% when charging starts, SOC=100% when charging is completed",
        "SOCDifference": "SOC Difference",
        "Note6": "SOC power: calculated by the battery manager (BMS), equal to (SOC when charging is completed-SOC when charging starts) * nominal capacity.",
        "Note5": "Statistical power: calculated by the battery monitor (Y-Hub), equal to the integral of current and time during charging.",
        "device": "Device",
        "Note4": "SOC power = (100-40)% * 225 = 135AH",
        "Note3": "Example: Nominal capacity=225AH, SOC=100% after fully charged, remaining SOC=40% before recharging",
        "Note2": "SOC charge: calculated by the battery manager (BMS), which is equal to the SOC difference between 2 charges * nominal capacity.",
        "Tips": "Tips"
    },
    "sideBar": {
        "blueToothCharge": "BLUETOOTH CHARGER",
        "btChargeData": "CHARGER DATA",
        "btYhubData": "BATTERY MONITOR DATA",
        "productOrder": "PRODUCTION RECORD",
        "docIndex": "Index",
        "btChargeVersion": "CHARGER FW UPDATE NOTICE",
        "PlanManage": "PLAN MANAGEMENT",
        "PRODUCT": "PRODUCT",
        "CURVE": "CURVE",
        "blueTooth": "BLUETOOTH",
        "SETTING": "SETTING",
        "LITHIUM_QRDATA": "LITHIUM QR DATA",
        "workOrder": "PRODUCT ISSUE TRACKING",
        "docSave": "Save",
        "DETAIL": "DETAIL",
        "MENUSETTING": "MENU SETTING",
        "WARNING": "WARNING",
        "childCompany": "BRANCH COMPANY",
        "i18n": "EDIT LANGUAGES",
        "COMPANY": "COMPANY",
        "SIM": "SIM",
        "doc": "Help manual",
        "FWUPDATE": "FW UPDATE",
        "FEEDBACK": "FEEDBACK",
        "appUpdateIndex": "APP NOTIFICATION",
        "LOCATION": "LOCATION",
        "smartQa": "SMARTQA",
        "ROLEMANAGEMENT": "ROLE MANAGEMENT",
        "simMagt": "SIM CARD MANAGEMENT",
        "fwUpdateNotice": "FW UPDATE NOTICE",
        "orderMagt": "ORDER MANAGEMENT",
        "BP": "BP QR CODE",
        "blueToothYhub": "BLUETOOTH YHUB",
        "btLiBatteryData": "LI BATTERY DATA",
        "YHUBREPORT": "YHUB REPORT",
        "GEOFENCING": "GEOFENCING",
        "CHARGELOG": "CHARGE LOG",
        "KISAE": "KISAE",
        "companyUser": "ACCOUNT",
        "KISAEINDEX": "KISAE Home",
        "serviceMagt": "SERVICE MANAGEMENT",
        "BATTERY": "BATTERY",
        "TRACKREPLAY": "TRACKREPLAY",
        "trafficMagt": "PACKAGE MANAGEMENT",
        "MODEL": "MODEL",
        "REPORT": "REPORT",
        "btVersionIndex": "VERSION UPDATE NOTIFICATION",
        "btDataIndex": "CHARGER DATA",
        "btLiBatteryIndex": "LI BATTERY DATA",
        "CHARGER_QRDATA": "CHARGER QR DATA",
        "FWUPLOAD": "FW UPLOAD",
        "LEASE": "LEASE",
        "DEVICES": "DEVICES",
        "deviceMagt": "DEVICE MANAGEMENT",
        "KISAEDATA": "KISAE Data",
        "HOME": "HOME",
        "APN": "APN MANAGEMENT"
    },
    "tagInput": {
        "Notset": "Not set",
        "set": "Set up",
        "seted": "Has been set",
        "someEmail": "If you want to enter multiple mailboxes, please separate them with \",\"",
        "Tips1": "A high-security password can make the account more secure. It is recommended that you change your password regularly.",
        "Tips3": "You have not set up an email address. It is recommended that you set up an email address.",
        "Tips2": "You have set a mobile number",
        "Tips5": "[All kinds of system and service notifications sent by the GPD will be sent to your email address.]",
        "Tips4": "You have set up an email",
        "Name": "Name",
        "Tips6": "You have not set a mobile phone number, it is recommended that you set a mobile phone number",
        "AccountSettings": "Account Settings",
        "mobilephonenumber": "mobile phone number",
        "lastLoginTime": "last login time",
        "modify": "modify",
        "mailbox": "E-Mail",
        "LoginAccount": "Login account",
        "now": "Current",
        "loginPassword": "login password"
    },
    "set": {
        "newmail": "New mailbox",
        "newName": "New name",
        "nowPhone": "Current phone number",
        "newUsername": "New username",
        "nowName": "Current name",
        "nowmail": "Current mailbox",
        "newphone": "New mobile phone",
        "username": "Current username"
    },
    "report": {
        "TimeSelection": "Time selection",
        "TotalCharged": "Total charged",
        "week": ": ",
        "TotalDischarged": "Total discharged",
        "first": "Week",
        "newWarnings": "Added warning"
    },
    "sim": {
        "ActivationTime": "Activation time",
        "year": "Year",
        "payer": "Payer",
        "ultra": "ultra",
        "beActivate": "To be activated",
        "review": "Paid for review",
        "Currency": "Currency",
        "IoTCardInfo": "IoT card information",
        "ConnectionStatus": "Connection Status",
        "Repair": "Repair",
        "UsedTraffic": "Used traffic",
        "unpaidReview": "Unpaid to be reviewed",
        "RemainFlow": "Remaining flow",
        "warnFee": "Expense cannot be blank, please re-enter",
        "Expiration": "Expiration",
        "Expired": "Expired",
        "Rule2": "((Unit price per megabit of traffic * Monthly traffic + monthly rent) * 12 + annual service fee) * Number of years = Price",
        "Rule1": "((Monthly rent * multiple * 12 months) + annual service fee) * Number of years = Price",
        "groupName": "group name",
        "cancellation": "Account cancellation",
        "auditTime": "Background audit time",
        "auditUser": "Background Auditor",
        "PackageId": "Package id",
        "discountValue": "Discount Value",
        "card": "card",
        "SIMMagt": "SIM card management",
        "FlowExceeds": "Flow exceeds",
        "PackageName": "Package name",
        "Beyond": "Beyond",
        "Overflow": "Overflow",
        "AreaName": "Area name",
        "More": "More than",
        "RemainOverflow": "Remaining/overflow",
        "audit": "Background audit",
        "latestData": "The latest data",
        "YearsPurchase": "Years of purchase",
        "realFlow": "Actual usage flow",
        "Deactivate": "Deactivate",
        "disabled": "Disabled",
        "RenewalMonth": "Renewal month",
        "UsageInfo": "Usage information",
        "serviceEndTime": "Service end time",
        "SIMMonthReport": "SIM Card Monthly Report",
        "CalculationRules": "Calculation rules",
        "trafficMagt": "Package management",
        "PaySuccess": "Payment successful",
        "RMB": "RMB",
        "fileInfo": "You can only upload up to 3 files, and each file size cannot exceed 5M",
        "MonthlyTraffic": "Monthly traffic",
        "GroupId": "Group id",
        "connected": "connected",
        "ExpirationExpired": "Expiration expired",
        "payerInfo": "Payer Information",
        "Rule1tips": "Note: Multiplier = the number of traffic M selected on the order page/50, for example, if you select 100M traffic, the multiple is 2",
        "serviceHours": "Service Hours",
        "UpdateTime": "Package update time",
        "SimICCID": "Sim card ICCID",
        "fileInfo2": "Maximum 3 files can be uploaded",
        "RenewalLog": "Renewal Log",
        "lifeCycle": "The life cycle",
        "Types": "Types of",
        "cardStatus263": "card status",
        "orderNumber": "Order number",
        "contactInfo": "Contact information (email/phone)",
        "Dollar": "Dollar",
        "SelectMonth": "Select month",
        "Attributes": "Attributes",
        "enterInt": "Please enter a positive integer",
        "selectDate": "Please select an activation date!",
        "GiveMonth": "Gift month",
        "areaAbnormal": "Area Abnormal",
        "exFlow": "Excess traffic for the month",
        "TestCard": "Test card",
        "Remaining": "Remaining",
        "Reset": "Reset",
        "discountExist": "$Discount has been set, cannot be set repeatedly",
        "all": "All",
        "EEA": "EEA",
        "LatestMonths": "Latest renewal months",
        "SetMeal": "Set meal",
        "UseAreaAbnormal": "Use area exception",
        "cardInfo": "Device card information",
        "months": "months",
        "pause": "Pause",
        "ServiceArea": "Service Area",
        "month": "month",
        "Price": "Price",
        "Recycle": "Recycle",
        "Value": "Value",
        "AreaCode": "Area code",
        "RepairStatus": "Repair status",
        "activation": "activation",
        "sureChange": "Are you sure about the change?",
        "PendingPay": "Reviewed for payment",
        "ReFlow": "Remaining traffic of the month",
        "NICstatus": "NIC status",
        "notConnected": "not connected",
        "payupdateTime": "Payment pending review time",
        "UseArea": "Use area",
        "CardStatus": "Card usage status",
        "DataUsage": "Data usage",
        "Rule3NoEEA": "((Unit price per megabit of traffic * Monthly traffic + monthly rent) * 12 + annual service fee) * Number of years = Price",
        "effective": "Effective",
        "discountName": "Discount name",
        "scrapped": "scrapped",
        "discountMagt": "Discount Management",
        "Renew": "Renew",
        "month2": "month",
        "uploadFiles": "upload files",
        "PackageFlow": "Package flow",
        "feeUnit": "USD/year",
        "payAccount": "Payment account",
        "userName": "Contact",
        "SimId": "Sim Card Id",
        "enterFee": "Please enter the service fee",
        "TrafficRemain": "Traffic remaining",
        "CommercialCard": "Commercial card",
        "Rule3EEA2": "((Unit price per megameter * (monthly traffic - 50) + monthly rent) * 12 + annual service fee) * Number of years = price",
        "Total": "Total",
        "Rule3EEA1": "(Monthly rent * 12 + annual service fee) * Number of years = Price",
        "BasicInfo": "Basic Information",
        "activated": "activated"
    },
    "adminView": {
        "GPDProvides": "GPD provides",
        "productModel": "Product Model",
        "Connected": "Connected",
        "newDevice": "New evice",
        "RelayOn": "on",
        "CurrentFirmVer": "Current firmware version",
        "planName": "Plan Name",
        "Edit": "Edit",
        "SystemVersion": "System version",
        "UniAnWeChat": "Uni-APP (Android WeChat applet)",
        "Hall300": "Hall 300A",
        "PrintNotes": "Print sticker notes",
        "ConfirmUpdate": "Confirm to update to this version?",
        "CalibrationStatus": "Status",
        "enterSoftHardV": "Select the correct software and hardware version",
        "ActivationDate": "Activation date",
        "BleAnWeChat": "Bluetooth (Android WeChat applet)",
        "CalibrationHistory": "Calibration History",
        "ChaAh": "charge electric quantity",
        "NotEqual": "Not Equal",
        "copyDataing": "During the data migration, please do not repeat the operation",
        "Expired": "Expired",
        "received": "Received",
        "Drillhole": "Drill hole",
        "Bonded": "Bonded",
        "DisWh": "discharge power",
        "CalOp8": "voltage setup",
        "CalOp7": "set ch1 current to zero",
        "CalOp9": "set updateindex",
        "DownloadSIM": "Download SIM card data",
        "CalOp4": "set soh",
        "CalOp3": "set soc",
        "Shunt300": "Shunt 300A",
        "CalOp6": "control relay",
        "FWBeforeUpdate": "FW version before update",
        "InUse": "In use, cannot update.",
        "CalOp5": "delete all data",
        "Canceled": "Canceled",
        "CalOp2": "set device timestamp",
        "CalOp1": "restart device",
        "External4G": "External 4G only",
        "Soc75": "Soc75",
        "FailUpdate": "Fail to update",
        "JSONData": "JSON data",
        "Soc70": "Soc70",
        "FileName": "File name",
        "Duration3": "Duration between start and end time must within 3 days.",
        "battery": "battery",
        "AUXVol": "Secondary voltage",
        "Created": "Created at",
        "OperationSource": "Operation source",
        "UpdateAt": "Update at",
        "Internal4GGPS": "Internal 4G+GPS",
        "Soc80": "Soc80",
        "enterApn": "Please input APN",
        "CustomerCode": "Customer code",
        "ConfirmDelete": "Confirm to delete permanently?",
        "WaterFillCover": "Water filling cover",
        "CalibrationUser": "User",
        "copyDataParamCannotbeEmpty": "Parameter cannot be empty",
        "YhubFirmVersion": "Yhub firmware version",
        "cleanData": "Clear new device data",
        "NotActivated": "Not activated",
        "SalesTicket": "Sales ticket",
        "inputRange": "inputRange",
        "Bayonet": "Bayonet",
        "series": "series",
        "PowerUp": "Power up at",
        "Soc90": "Soc90",
        "MiniProgram": "Uni-APP(Mini Program)",
        "NoConnection": "No connection",
        "GroupName": "Group name",
        "system72": "72V system",
        "Capacity5": "Capacity(C5)",
        "MenuType": "Menu type",
        "NetworkStatus": "Network status",
        "Soc50": "Soc50",
        "beSent": "To be sent",
        "showPosition": "Show Position",
        "descriptions": "descriptions",
        "Interlock": "Interlock",
        "dischargeRate": "discharge rate",
        "Name": "Name",
        "NormallyOpen": "Normally open",
        "printProductDate": "Print production date",
        "tiedBarcodNum": "Number of tied barcodes",
        "statusChange": "Is the status changed to in production after the confirmation is approved?",
        "Version": "Version",
        "CurveNo": "Curve No",
        "defaultConfig": "No configuration information is set, showing the default configuration",
        "configInfo": "Config Info",
        "barcode": "BarCode",
        "add": "Add",
        "SIMID": "SIM card ID",
        "system84": "84V system",
        "Soc60": "Soc60",
        "test": "test",
        "networkModule2": "network module",
        "SettCreated": "Setting created at",
        "AddNextMenu": "Add next layer menu",
        "Transferring": "Transferring",
        "Brand": "Brand",
        "underReview": "Under review",
        "SIMCardInfo": "SIM card info",
        "uploadCorrectFile": "Please upload correct file, example",
        "BleIOSWeChat": "Bluetooth (IOS WeChat applet)",
        "MainCurrent": "Main current sensor type",
        "LastConnection": "Last connection",
        "Incorrect": "Incorrect file name",
        "Region": "Region/Country",
        "UseComma": "Use comma(,) for multiple input",
        "Soc30": "Soc30",
        "SelectRecords": "Select records to be deleted",
        "showHalfV": "Show HalfV",
        "Soc100": "Soc100",
        "Yes": "Yes",
        "calcSuccess": "The calculation is successful!",
        "inProduction": "In production",
        "DeleteVersion": "Delete this version?",
        "AntennaInstallation": "Antenna installation",
        "mcuid": "mcuid",
        "MenuSubID": "Menu sub ID",
        "DisAh": "discharge electric quantity",
        "CustomerName": "Customer name",
        "CalibrationValue": "Value",
        "CANbus": "CANbus",
        "UpdateHistory": "Settings update history",
        "system60": "60V system",
        "WaitConfirm": "Waiting confirmation",
        "Soc40": "Soc40",
        "CurrentRate": "In Current Rate",
        "UploadVersion": "Upload version",
        "IMEI": "IMEI",
        "MenuNavigation": "Menu (with navigation)",
        "ProductID": "ProductID",
        "createBy": "CreateBy",
        "LevelSensor": "Level sensor",
        "OutCurrentRate": "Out Current Rate",
        "External4GGPS": "External 4G+GPS",
        "NormallyClose": "Normally close",
        "select": "select",
        "Soc10": "Soc10",
        "QRPath": "QR path",
        "Manual": "Manual",
        "ContactPerson": "Contact person",
        "GroupID": "Group ID",
        "Equal": "Equal",
        "MenuNoNavigation": "Menu (no navigation)",
        "PleaseEnterSN": "Please enter the serial number, multiple serial numbers need to use enter, all means all",
        "Example": "Example",
        "DeviceInfo": "Device info",
        "PackageID": "Package ID",
        "system36": "36V system",
        "ConnectionStatus": "Connection status",
        "AUXCurrent": "Secondary current",
        "showBind": "Binding information",
        "Soc20": "Soc20",
        "versionType": "Version type",
        "FWVersionUpdate": "FW version after update",
        "copyDataParamError": "Parameter Error",
        "Offline": "Offline",
        "Shipped": "Shipped",
        "productInfo": "Product Info",
        "Soc25": "Soc25",
        "chargeRate": "charge rate",
        "MadeQTY": "Made QTY",
        "oldDevice": "Old Device",
        "Separated": "Separated",
        "pmcProductId": "PMC NO",
        "system48": "48V system",
        "pleaseCheck": "There are unqualified entries in the configuration information, please check",
        "Current": "Current",
        "networkModule": "network module version",
        "Alldevices": "All devices",
        "BrandOrModel": "Brand/Model",
        "CurrentVersion": "Current version",
        "ManufactureCode": "Manufacture code",
        "EnterCorrect": "Enter correct charging curve,example: b123/123",
        "Upload": "Upload firmware for update",
        "CalOp16": "set shunt calibration value to zero",
        "CalOp15": "set hall calibration value to zero",
        "Capacity20": "Capacity(C20)",
        "CalOp14": "set voltage calibration value to zero",
        "CalOp13": "delete device record",
        "CalOp12": "set aux voltage",
        "capacity": "capacity",
        "manufacturer": "manufacturer",
        "CalOp11": "set ch2 current to zero",
        "CalOp10": "set charge/discharge power",
        "SIMStatus": "SIM card status",
        "Hall800": "Hall 800A",
        "SentSuccess": "Sent successfully",
        "system12": "12V system",
        "hardwareVersion": "Yhub hardware version",
        "copyDataSuccess": "The operation is successful, the data migration will start soon, please wait!！",
        "CustomerNum": "Customer part number",
        "TemSensor": "Temperature sensor type",
        "BleIOSApp": "Bluetooth (IOS APP)",
        "CalibrationTime": "Time",
        "Dimension": "Dimension",
        "EditBattery": "Edit battery",
        "BondCompanyInfo": "Bonded company info",
        "Default": "Default",
        "produce": "produce",
        "MenuName": "Menu name",
        "Type": "Type",
        "BleAnApp": "Bluetooth (Android App)",
        "Model": "Model",
        "system24": "24V system",
        "Online": "Online",
        "CalibrationOperation": "Operation",
        "LowVoltage": "Low voltage for hardware protection",
        "prepared": "Prepared by customer",
        "Ignition": "Ignition",
        "FileBin": "File extension must be \"bin\"",
        "NotBonded": "Not bonded yet",
        "Update": "Update",
        "ChaWh": "charge power",
        "Soc0": "Soc0",
        "UpdateBy": "Update by",
        "TargetQTY": "Target QTY",
        "Sort": "Sort",
        "MenuPath": "Menu path",
        "IncorrectFile": "Incorrect file extension",
        "Updated": "Updated",
        "Have": "Have",
        "ChargProfile": "Charging curve",
        "SNError": "Please enter the correct serial number, multiple serial numbers need to use enter, all means all",
        "Certification": "Certification",
        "RoleName": "Role name",
        "orderTicket": "Customer order ticket",
        "CompanyInfo": "Company info",
        "File": "File",
        "curveNumber": "curveNumber",
        "YhubVersion": "Yhub protocol version",
        "WarrantyDate": "Warranty expiry date",
        "NegativePost": "Negative post",
        "Internal4G": "Internal 4G only",
        "delete": "Delete",
        "copyDataPopTitle": "Copy Data",
        "Hourmeter": "Hourmeter",
        "InWarehouse": "In the warehouse",
        "wait5": "Sending successfully, the list will be refreshed soon, it is estimated to take 5 minutes, please wait patiently",
        "SIMICCID": "SIM card ICCID",
        "currentProductId": "Current ProductId",
        "No": "No",
        "DeviceID": "Device ID",
        "UniIOSWeChat": "Uni-APP (IOS WeChat Mini Program)",
        "FirmwareVersion": "Firmware Version",
        "RelayOff": "off",
        "OrderDate": "Order date",
        "PCBVersion6": "PCB Version 6",
        "PCBVersion5": "PCB Version 5",
        "MenuID": "Menu ID",
        "softHardV": "Software and hardware version",
        "PCBVersion2": "PCB Version 2",
        "PCBVersion1": "PCB Version 1",
        "warnInfo": "Warn Info",
        "PCBVersion4": "PCB Version 4",
        "PCBVersion3": "PCB Version 3",
        "Model2": "Model",
        "Tel": "Tel",
        "UploadSuccess": "Upload successfully",
        "Track": "Track barcode"
    },
    "i18nPage": {
        "English": "English",
        "French": "French",
        "deleteOne": "Are you sure to delete this piece of data?",
        "module": "Function module",
        "Korean": "Korean",
        "Japanese": "Japanese",
        "ft": "Traditional Chinese",
        "Germany": "Germany",
        "Key": "Key string",
        "Solution": "Solution",
        "zh": "Simplified Chinese"
    },
    "M485": {
        "remainAH": "Remaining capacity",
        "Cycles": "Cycle life",
        "no": "No.",
        "MonTem": "Cell temperature",
        "cellV": "Cell voltage",
        "totalV": "Total voltage",
        "AmbientTem": "Ambient temperature",
        "FullChargeAH": "Full charge capacity",
        "FullDisAH": "Full discharge capacity",
        "version": "Software and hardware version number",
        "MOSTem": "MOS temperature",
        "DesignAH": "Design capacity"
    },
    "blueTooth": {
        "BLEMeterData": "BLE meter reading data",
        "innerTem": "Internal temp.",
        "BLEbroadcast": "BLE broadcast",
        "blueTooth": "Bluetooth",
        "chargerTime": "Charger time"
    },
    "feedBack": {
        "image": "Image",
        "HardwareProblem": "Hardware product issues",
        "other": "Other",
        "deviceUnresolved": "The current device has unresolved issues",
        "Keyword": "Keyword",
        "ImgUploadFailed": "Image upload failed, please try again!",
        "formatWrong": "The format is wrong, please upload a picture!",
        "postsale": "postsale engineer",
        "AssociatedDevice": "Associated device (SN)",
        "CannotSpaceInfo": "Cannot enter blank information",
        "SystemProblem": "System background problems",
        "ComRecord": "Communication record",
        "Processing": "Processing",
        "QRProblem": "QR scan code problem",
        "Untreated": "Untreated",
        "expired": "Expired",
        "APPProblem": "APP problem",
        "NoComRecord": "No communication record",
        "overSize": "The image size cannot exceed 10M, please try again!",
        "Void": "Void",
        "Processed": "Processed"
    },
    "appUpdate": {
        "APPDoc": "Documentation URL",
        "upload": "Uploading...",
        "AppCenterMagt": "Application Center Management",
        "AppNoteFt": "Application Note (Traditional Chinese)",
        "OrdinaryUpgrade": "Ordinary upgrade",
        "UpgradeInstrucFt": "Upgrade Instructions (Traditional Chinese)",
        "AppName": "Application name",
        "UpgradeInstruct": "Upgrade Instructions",
        "Uploaded": "Uploaded at",
        "AppNoteEn": "Application Note (English)",
        "logo": "Logo",
        "Supported1": "Supported",
        "UpgradeInstrucKl": "Upgrade instructions (Korean)",
        "AppNoteKl": "Application Note (Korean)",
        "AppNoteJa": "Application Note (Japanese)",
        "DownloadLink": "Download link",
        "EnterVersion": "Please enter the correct version number. Such as: 1.1.1/111",
        "GooglePlay": "Google play store",
        "website": "website",
        "UpgradeInstrucEn": "Upgrade Instructions (English)",
        "UpgradeAddress": "Upgrade address",
        "UpgradeMethod": "Upgrade method",
        "AppNoteZh": "Application Note (Simplified Chinese)",
        "AppleAppstore": "Apple App store",
        "UpgradeInstrucZh": "Upgrade Instructions (Simplified Chinese)",
        "Android": "Android",
        "version_prompt": "Version upgrade prompt",
        "AppId": "Application id",
        "UpgradePath": "Upgrade path",
        "UpgradeInstrucJa": "Upgrade instructions (Japanese)",
        "PlatformType": "Platform type",
        "notUpgrade": "Do not upgrade",
        "UpgradeInstrucDe": "Upgrade instructions (German)",
        "AppNoteDe": "Application Note (German)",
        "MandUpgrade": "Mandatory upgrade"
    },
    "eveF477": {
        "No": "No",
        "LowestCellV": "Lowest cell voltage",
        "LowTemInNo": "Serial number in the lowest temperature module",
        "highCellVInNo": "The highest cell voltage internal serial number",
        "TotalVoltage": "Total voltage",
        "MaxCellV": "Maximum cell voltage",
        "LowTemModNo": "Minimum temperature module number",
        "lowCellVInNo": "Lowest cell voltage module number",
        "MaxTemModNo": "Maximum temperature module number",
        "WarnGrade3": "Level 3 warning",
        "highCellVModNo": "The highest single voltage module number",
        "highTemInNo": "Serial number in the highest temperature module",
        "LowestCellVInNo": "Lowest cell voltage internal serial number",
        "WarnGrade2": "Secondary warning",
        "WarnGrade1": "First level warning",
        "TotalCurrent": "Total current",
        "BMSAddress": "BMS address",
        "WarnGrade": "Warning level"
    },
    "doc": {
        "ChineseHKContent": "Chinese (traditional) content",
        "FrContent": "French content",
        "FrTitle": "French title",
        "titleCannotbeEmpty": "Title cannot be empty",
        "Category": "Classification",
        "DeTitle": "German title",
        "JaTitle": "Japanese title",
        "ChineseContent": "Chinese (Simplified) Content",
        "EnglishTitle": "English title",
        "ChineseHKTitle": "Chinese (traditional) title",
        "DeContent": "German content",
        "JaContent": "Japanese content",
        "KoContent": "Korean content",
        "ChineseTitle": "Chinese (Simplified) title",
        "helpCenter": "Help Center",
        "EnglishContent": "English content",
        "Sort": "sort",
        "KoTitle": "Korean title",
        "PlatformType": "platform type"
    },
    "kisae": {
        "InvAcOutFrequency": "InvAcOutFrequency",
        "batLowVolProtect": "Battery low voltage protection value",
        "BtsTemperature": "BtsTemperature",
        "CreatedAt": "CreatedAt",
        "MainProgramRev": "MainProgramRev",
        "AcInTime": "AcInAcInTime",
        "defines": "Restore default configuration",
        "DisplayDataRev": "DisplayDataRev",
        "backupPowerConfig": "Backup power configuration",
        "InvAcOutTime": "InvAcOutTime",
        "high": "high",
        "chargeStageNum": "Number of charging stages",
        "AcInFrequency": "AcInFrequency",
        "KisaeInverterConfigData": "kisae inverter configuration",
        "MachineModel": "MachineModel",
        "DcMosTemperature": "DcMosTemperature",
        "BatType": "BatType",
        "MachineStatus": "MachineStatus",
        "batLowVolRst": "Battery low voltage protection recovery value",
        "savePower": "Power saving",
        "MainDataRev": "MainDataRev",
        "KisaeBroadcastData": "kisae broadcast data",
        "KisaeLiBatteryDetailData": "kisae lithium battery data",
        "BatOutCurrent": "BatOutCurrent",
        "volABS": "ABS voltage",
        "currFloat": "Float current",
        "InvAcOutPower": "InvAcOutPower",
        "batTemp": "Battery temperature compensation",
        "Current": "Current",
        "DisplayProgramRev": "DisplayProgramRev",
        "KisaeDetailData": "kisae detail data",
        "volFloat": "Float voltage",
        "Temperature": "Temperature",
        "acCurLimit": "Mains input current limit",
        "AcMosTemperature": "AcMosTemperature",
        "AmbientTemperature": "AmbientTemperature",
        "ConfigChgCurrent": "ConfigChgCurrent",
        "currBUL": "bul current",
        "rechargeVol": "Recycle voltage",
        "RelayTemperature": "RelayTemperature",
        "AcInPower": "AcInPower",
        "ecoMode": "Power saving mode",
        "InvAcOutCurrent": "InvAcOutCurrent",
        "InvAcOutVoltage": "InvAcOutVoltage",
        "AcInCurrent": "AcInCurrent",
        "AcInEfficiency": "AcInEfficiency",
        "Voltage": "Voltage",
        "alarmSwitch": "Buzzer switch",
        "BmsStatus": "BMSBmsStatus",
        "BatChgStage": "BatChgStage",
        "ConfigChgVoltage": "ConfigChgVoltage",
        "BatVoltage": "BatVoltage",
        "SOC": "SOC",
        "KisaeInverterDetailData": "kisae inverter data",
        "shutdownCurrent": "Shutdown current",
        "TransfTemperature": "TransfTemperature",
        "InvAcOutEfficiency": "InvAcOutEfficiency",
        "AcInVoltage": "AcInVoltage",
        "acChargeSwitch": "AC charging switch",
        "inverterStatus": "Inverter Status",
        "jsonData": "data",
        "BatChgCurrent": "BatChgCurrent",
        "currSystem": "Current system",
        "ErrorCode": "ErrorCode",
        "batLowVolAlarm": "Battery low voltage warning value",
        "DeviceName": "DeviceName"
    },
    "liBattery": {
        "ntcs": "NTC Content",
        "BaseInfo": "BasicInfo",
        "CreatedAt": "CreatedAt",
        "overvoltageProtect": "OverVoltageProtection",
        "chargingHighTempProtect": "ChargingHighTempProtection",
        "cycles": "cycles",
        "cellOvervoltageProtect": "CellOverVoltageProtection",
        "chargingHighTemp": "ChargingHighTemp",
        "ViewData": "View Data",
        "undervoltage": "UnderVoltage",
        "dischargingLowTempProtect": "DischargingLowTempProtection",
        "cellUndervoltageProtect": "CellLowVoltageProtection",
        "undervoltageProtect": "lowVoltageProtection",
        "Protected": "Protected",
        "DischargeSwitch": "Discharge Switch",
        "ChargeSwitch": "Charge Switch",
        "chargingLowTempProtect": "ChargingLowTempProtection",
        "dischargOvercurrentProtect": "DischargOverCurrentProtection",
        "softwareLockMOSProtect": "SoftwareLockMOSProtection",
        "Unprotected": "Unprotected",
        "version": "Version",
        "CellVoltageData": "CellVoltageData",
        "cellUndervoltage": "CellUnderVoltage",
        "Current": "Current",
        "cellOvervoltage": "CellOverVoltage",
        "Temperature": "Temperature",
        "chargingLowTemp": "ChargingLowTemp",
        "dischargingLowTemp": "DischargingLowTemp",
        "cell": "Cell Count",
        "BatteryProtectionStatistic": "BatteryProtectionStatistic",
        "Off": "Off",
        "capacity": "Capacity",
        "dischargeMOSBreakdownMarkProtect": "DischargeMOSBreakdownMarkProtection",
        "fets": "FET Status",
        "remainCapacity": "Remain Capacity",
        "balances": "Balance Status",
        "chargOvercurrent": "ChargingOverCurrent",
        "dischargingHighTemp": "DischargingHighTemp",
        "dischargingHighTempProtect": "DischargingHighTempProtection",
        "productionDate": "Production Date",
        "Voltage": "Voltage",
        "dischargOvercurrent": "DischargingOverCurrent",
        "ntc": "NTC Count",
        "CellVoltage": "CellVoltage",
        "rsoc": "SOC",
        "chargOvercurrentProtect": "ChargOverCurrentProtection",
        "frontEndEetectionICErrorProtect": "FrontEndDetectionICErrorProtection",
        "restart": "Restart",
        "SOC": "SOC",
        "shortProtection": "ShortProtection",
        "protections": "Protection Status",
        "chargingMOSBreakdownMarkProtect": "ChargingMOSBreakdownMarkProtection",
        "overvoltage": "OverVoltage",
        "shortProtectionProtect": "ShortCircuitProtection",
        "UpdateTime": "UpdateTime",
        "DeviceName": "DeviceName",
        "On": "On"
    },
    "titles": {
        "socDetail": "View power data",
        "moreBtn": "More operations",
        "toInfoDetail": "View data details",
        "toReport": "View report",
        "toWeekReport": "View weekly report",
        "edit": "Edit",
        "mapChange": "Map switch",
        "toDetail": "View details",
        "addQuestion": "Add Question",
        "unbindDevice": "Unbind device",
        "editConfig": "Edit configuration information",
        "delete": "Delete",
        "temChange": "Temperature switch",
        "addProOrder": "Add production order",
        "download": "Download",
        "search": "Search",
        "editPassword": "Change password",
        "addDevice": "Add device",
        "langChange": "Language switch",
        "uploadChargeRecord": "Upload charging record",
        "addDeviceInfo": "Add device information",
        "bleDetail": "View bluetooth data",
        "addAccount": "Add account",
        "addModel": "Add model"
    },
    "product": {
        "urlDefault": "url format (default)",
        "accountProModel": "Customer Product Model",
        "enterDigitBetween": "Please enter an integer of $1 or $2 decimal places",
        "enterIntBetween": "Please enter an integer of $1",
        "QRCodeContent": "QR code content",
        "snFormat": "SN:xxx format",
        "limitSendFreq": "Acquisition frequency",
        "paramError": "There is a parameter error in $, please check"
    },
    "device_log": {
        "10001": "yhub data copy success, from:$1, to:$2",
        "10002": "yhub data copy fail, from:$1, to:$2",
        "10101": "The vehicle has been maintained periodically",
        "10102": "The vehicle will undergo periodic maintenance on $1",
        "10103": "Ignore vehicle periodic maintenance reminder",
        "10111": "The vehicle has undergone annual maintenance",
        "10112": "The vehicle will undergo annual maintenance for $1",
        "10113": "Ignore annual maintenance reminders for vehicles",
        "10201": "The battery has been maintained periodically",
        "10202": "The battery will undergo periodic maintenance on $1",
        "10203": "Ignore battery periodic maintenance reminder",
        "10211": "The battery has undergone annual maintenance",
        "10212": "The battery will undergo annual maintenance for $1",
        "10213": "Ignore annual battery maintenance reminders",
        "10301": "The battery has been capacity maintained",
        "10302": "The battery will undergo capacity maintenance on $1",
        "10303": "Ignore battery capacity maintenance reminder",
        "10401": "The battery has been charged and discharged for maintenance",
        "10402": "The battery will undergo charging and discharging maintenance on $1",
        "10403": "Ignore the reminder that the battery has not been used for a long time",
        "10501": "vehicle periodic maintenance reminder expired",
        "10502": "battery periodic maintenance reminder expired",
        "10601": "$1 moved the device to company  $2",
        "10602": "$1 Set Yhub server to $2",
        "10603": "$1 Set Yhub Telecom Operator to $2",
        "10701": "Device name: $1 rename to $2 ($3)",
        "20001": "Data service valid for renewal for $1 year successfully.",
        "20002": "The validity period of the data service has expired, the lower collection frequency is $1, and the last collection frequency is $2",
        "20003": "Data service traffic usage is abnormal, reduce the collection frequency to level $1, and the last collection frequency to level $2",
        "20004": "The system automatically restores the data collection frequency to level $1, and the last acquisition frequency to level $2"
    },
    "index": {
        "device_fine": "Device works fine",
        "mt-BoomLift": "Boom Lift",
        "mt-Sweeper": "Sweeper",
        "Configuration": "Configuration",
        "Charge_and_discharge_record": "Charge and discharge record",
        "ViewDetails": "View details",
        "add_charger": "Add charger",
        "switched_map": "Switched to satelite mode",
        "equipment_warning": "Equipment warning",
        "Currency": "Currency",
        "record": "Report",
        "7_days": "Network rate in the past 15 days",
        "mt-Folk": "Forklift",
        "no_network": "Networking information was not found, unable to bind, please contact the administrator",
        "UsedTraffic": "Used traffic",
        "enterPlanName": "Please enter a plan name",
        "alibaba": "Alibaba Cloud (Hong Kong)",
        "sim_card_brand": "SIM card brand",
        "devices": "Device list",
        "edit": "Edit",
        "fullScreen": "Full screen",
        "device_distribution": "Device overview",
        "charger": "Charger",
        "model_not_emp": "The battery model cannot be empty",
        "payment_account": "Payment account",
        "google_cloud": "Google Cloud (Belgium)",
        "device_is_bound": "The device is bound!",
        "helpCenterP": "For everyone's common usage questions, the answers are here",
        "cap_not_emp": "Capacity cannot be empty",
        "ResidualFlow": "Residual flow",
        "level_status": "Liquid level status",
        "helpCenter": "Help Center",
        "Insufficient": "Insufficient permissions",
        "loading_finish": "ok",
        "network_status": "Status",
        "lithium_battery": "Lithium Battery",
        "mt-Marine": "Marine",
        "MyModule": "My module",
        "hostInfo": "Vehicle Infomation",
        "my_GPDEnergy": "Energy Management",
        "refresh": "Refresh",
        "tem_display": "Temperature display",
        "battery_tem": "Battery temp.",
        "CommunicationFn": "Communication function",
        "add_monitoring": "Add monitoring",
        "total_equipment": "Total",
        "export_device": "Export device",
        "lease": "Lease",
        "detailed_line_chart": "Detailed data line chart",
        "mt-scissor": "Scissor car",
        "Dollar": "Dollar",
        "SiteName": "Use address",
        "my_kisae": "Energy Management",
        "OtherModules": "Other modules",
        "data_server": "Data Server",
        "available_languages": "[{\"label\":\"中文简体\",\"value\":\"zh_CN\"},{\"label\":\"中文繁体\",\"value\":\"zh_HK\"},{\"label\":\"English\",\"value\":\"en\"},{\"label\":\"Deutsche\",\"value\":\"de\"},{\"label\":\"日本語\",\"value\":\"ja\"},{\"label\":\"한국어\",\"value\":\"ko\"},{\"label\":\"Français\",\"value\":\"fr\"}]",
        "GPS": "GPS",
        "lease_mana": "Lease management",
        "my_charger": "Charge record",
        "device_management": "Device management",
        "not_support_remote": "This monitor does not support remote configuration",
        "details": "Details",
        "View_device_distribution": "View device distribution",
        "ActiveDevices": "Active devices",
        "export": "Export",
        "add_kisae": "Add KISAE",
        "add": "Add",
        "deal_in_time": "Please deal with it in time",
        "Undefined": "(Undefined)",
        "no_location": "Sorry! No location information",
        "sn_not_emp": "SN cannot be empty",
        "YData": "Big data visualization management",
        "ple_enter": "Please enter",
        "collection": "Collection successful",
        "Account_management": "Account Management",
        "changeName": "Change Name",
        "collection_canceled": "Collection canceled",
        "SiteView": "Site overview",
        "Please_select_time_range": "Please select a time range!",
        "sure_info_file": "Are you sure you need to export the following device information?",
        "TotalDevices": "Total devices (units)",
        "add_rental": "Add rental",
        "Desktop_customization": "Desktop customization",
        "data_plan": "Data plan",
        "add_lithium_battery": "Add lithium battery",
        "Manage_my_account": "Manage my account",
        "batteryInfo": "Battery Information",
        "view_info_calibration": "View monitor information and perform remote calibration",
        "monitor_settings_remote": "Monitor information settings, remote configuration",
        "dele_succ": "Successfully deleted",
        "download_report": "Download report",
        "my_order": "Data service order",
        "belgian_platform": "Belgian management platform",
        "news": "Notifications",
        "networking_rate": "Networking rate",
        "yes": "Yes",
        "system_name": "System",
        "weekly_url": "https://www.gpdcloud.net/#/w/yhub",
        "base_info": "Basic Information",
        "Arrangement": "Arrangement",
        "home": "Home",
        "notConfig": "Could not get configuration",
        "SubSysteminfo": "Subscription system mssage",
        "theme_select": "Theme selection",
        "location": "Location",
        "LatestUpload": "Latest upload",
        "PurchaseDataServices": "Purchase data services",
        "SchemePreview": "Scheme preview",
        "favorite_monitor": "Favorite monitor, default list at the top, can be viewed in my favorites",
        "MoreInfo": "More",
        "tips": "Tips",
        "enable": "enable",
        "my_focus": "My focus",
        "online_device": "Online",
        "pc_not_emp": "Pc cannot be empty",
        "ExcessFlow": "Excess flow",
        "device_position": "Device positioning",
        "loading": "loading...",
        "place3": "Please enter the device name",
        "place1": "Find the SN on the device sticker",
        "place2": "Please enter the activation code",
        "PreviewScheme": "Preview scheme",
        "device_total": "Device total",
        "card": "card",
        "mt-other_cars": "Other",
        "log": "Log",
        "china_platform": "China Management Platform",
        "mt-washing": "Washing truck",
        "update_time": "Update time",
        "choose_a_type": "Choose a type",
        "last_online_time": "Last online",
        "OwnerView": "Owner overview",
        "view_location": "View monitor positioning",
        "sign_out": "Sign out",
        "SubUsageInfo": "Subscription usage message",
        "quan": "",
        "inline_total": "Total Network",
        "in_the_last": "Probability that all devices were connected within 24 hours in the last 15 days",
        "mt-Scrubber": "Scrubber",
        "my_Energy": "Energy Management",
        "RMB": "RMB",
        "MonthlyTraffic": "Monthly traffic",
        "abnormal_device": "Abnormal",
        "help": "Help",
        "add_succ": "Added successfully",
        "disable": "Disable",
        "SchemeNameInfo": "Scheme default naming rules: scheme name_year month day. You can add new names.",
        "report": "Analysis",
        "my_yhub": "Battery monitor",
        "Alarm_information": "Device message",
        "no_permiss_text": "Reminder: DRM platform services have not been activated yet or trial services have ended. Please contact customer service",
        "time_frame": "Time frame",
        "real_time": "Overview",
        "device_type": "Device type",
        "switch_servers": "Switch servers",
        "customPlan": "Custom Plan",
        "enterInt": "Please enter an integer",
        "quick_selection": "Quick selection",
        "mt-GolfCar": "Golf cart",
        "device_name_empty": "The device name cannot be empty",
        "download": "Download",
        "UploadChargeRecord": "Upload charging record",
        "set_up": "Set up",
        "openTotalWarn": "Total alerts need to be turned on to subscribe to messages",
        "battery_power": "Battery power",
        "mt-UtilityVehicle": "Multi function vehicle",
        "planNameExists": "Project name already exists",
        "Customize": "Customize",
        "Add_my_device": "Add my device",
        "infoPusher": "Message sender",
        "kisae": "KISAE",
        "down_info": "Download monitor information",
        "mt-AGV": "Automated Guided Vehicle",
        "IncorrectPasscode": "The activation code (PC) is incorrect, please refer to the PC information on the sticker",
        "mt-AerialWorkPlatform": "Aerial work platform",
        "editPlanName": "Scheme name (default): $, do you need to modify it?",
        "geofencing": "Geofencing",
        "new_device": "New device",
        "no": "No",
        "totalRecords": "Total",
        "activation_code": "Activation code",
        "data_visualization": "Data visualization",
        "delete": "Delete",
        "ExitFullScreen": "Exit Full Screen",
        "mt-AGC": "Automatic guided transport vehicle (simplified)",
        "binding_time": "Binding time",
        "total": "Total",
        "my_lithium": "My Lithium Battery",
        "branch_details": "Branch details",
        "stay_tuned": "Stay tuned",
        "track": "Active track",
        "default_sort": "Default sort",
        "loading_complete": "Loading is complete!",
        "my_lease": "My Lease",
        "add_device": "Add Device",
        "mt-RVs": "RVs",
        "SignalAcquisition": "Signal Acquisition",
        "online": "Online",
        "TotalWarnDevice": "Total devices with warning (units)",
        "Desktop_management": "Desktop Management",
        "sn_notfound": "SN query failed!"
    },
    "chargerIndex": {
        "event_190": "The GPSC2036 is built by GPD",
        "trips_complete": "Transfer complete.",
        "event_194": "The GPSC4080 is built by GPD",
        "btn_reconnect": "Reconnect",
        "event_193": "The GPSC8080 is built by GPD",
        "event_192": "The GPSC2536 is built by GPD",
        "event_191": "The GPSC2572 is built by GPD",
        "status_info": "Status",
        "event_198": "The GPSC7024 is built by GPD",
        "event_197": "The GPSC3096 is built by GPD",
        "event_196": "The GPSC7048 is built by GPD",
        "event_195": "The GPSC10048 is built by GPD",
        "event_64": "IGBT high temperature protection",
        "event_62": "Close the output when the bridge stack temperature is too high",
        "event_61": "Power limiting due to excessive bridge pile temperature",
        "event_67": "The mains frequency exceeds the limit",
        "event_66": "Low temperature or loss of RT in the aircraft",
        "event_65": "Low temperature battery",
        "error_7": "Address declaration error",
        "error_8": "Error reading memory address",
        "event_9": "Mains lost",
        "btn_done": "Done",
        "index_title": "Search Device",
        "trips_connecting": "Connect the charger...",
        "trips_newVersion": "The service provider has pushed new firmware to keep the device stable; please upgrade as soon as possible.",
        "event_183": "The GPSC5048 is built by GPD",
        "event_5": "Charger High Tempreature Protection",
        "event_182": "The GPSC2572 is built by GPD",
        "event_6": "Power supported mode",
        "event_181": "The GPSC3548 is built by GPD",
        "event_7": "Charging Profile Manually Changed",
        "device_connecting": "The device is connecting, please wait",
        "event_180": "Create GPSC3024 model",
        "event_8": "Charging Profile Changed Through USB Upload",
        "trips_device_not_searched": "The device cannot be searched temporarily, please try again later",
        "event_187": "The GPSC2548 is built by GPD",
        "event_186": "The GPSC3624 is built by GPD",
        "event_185": "The GPSC6024 is built by GPD",
        "personal": "Personal",
        "event_184": "The GPSC6048 is built by GPD",
        "event_189": "The GPSC3536 is built by GPD",
        "event_188": "The GPSC1548 is built by GPD",
        "schedule_charging": "Schedule charging",
        "menu_lang": "Language",
        "event_1": "Start Charging",
        "event_2": "End Charging",
        "event_3": "Battery Low Voltage during charging",
        "event_4": "Battery High Temperature Protection",
        "error_3_desc": "The internal or ambient temperature of the stabilized power supply is too high",
        "event_176": "The GPXC3024 is built by GPD",
        "event_179": "The GPSC7524 is built by GPD",
        "event_178": "",
        "event_177": "The GPSC4072 is built by GPD",
        "info_succ": "Information obtained successfully",
        "starting_time": "Starting time",
        "error_0": "The charger is normal",
        "error_1": "No battery detected",
        "error_2": "Mains abnormal",
        "error_3": "Machine high temperature protection",
        "error_4": "Battery high temperature protection",
        "date-out": "The date is out of range~",
        "error_5": "Internal failure of the machine",
        "error_6": "Battery voltage too high",
        "version_info": "Firmware Update",
        "trips_calibration": "Calibration succeeded",
        "c_b_c": "This charging capacity",
        "btn_cancel": "Cancel",
        "trips_stop2cancel": "Click 'Stop' to cancel the update",
        "to": "to",
        "error_10": "Relay malfunction",
        "please_sign_in": "Please sign in",
        "error_11": "Battery error",
        "trips_need2change": "If you need to change the battery configuration curve, please click the edit button on the right~",
        "version_num": "Version",
        "error_16": "PFC undervoltage",
        "available_languages": "English/en,中文简体/zh_CN,中文繁體/zh_HK",
        "equipment_type": "Device type",
        "error_17": "Charging mode error",
        "error_14": "Low temperature protection for batteries",
        "config_info": "Settings",
        "error_15": "Insulation fault | | Communication abnormality | | XG fault flag",
        "error_12": "BTS malfunction",
        "btn_up": "Start upgrading",
        "error_13": "Output overvoltage",
        "event_20": "Mains alnormal",
        "you_can_choose": "You can choose the best charging time according to the local peak, flat and valley electricity price",
        "o_c": "Current output",
        "event_24": "Firmware was updated",
        "event_23": "Surges had been detected",
        "event_22": "Maintenance Forced",
        "event_21": "Float Charging Mode",
        "week-day": "Sun.,Mon.,Tues.,Wed.,Thur.,Fri.,Sat.",
        "event_28": "Catch processing data during charging",
        "unable_schedule": "Unable to schedule charging",
        "event_27": "Download record",
        "event_26": "External Switch opened",
        "event_25": "External Switch closed",
        "event_29": "BMS required operation",
        "connection_failed": "Device connection failed, please reconnect",
        "btn_confirm": "Confirm",
        "o_v": "Voltage output",
        "error_5_desc": "Disconnect the AC power supply, restart the stabilized power supply for charging",
        "update_log": "Update log",
        "event_31": "BMS required exiting",
        "event_30": "Charger was started by BMS",
        "trips_sending": "Sending",
        "event_35": "Charging Profile was changed through Button-Handle",
        "event_34": "BMS found battery pack protection",
        "event_33": "BMS stopped outputing",
        "event_32": "Configuration parameter_command communication timeout",
        "event_39": "Exit GPD LITHIUM",
        "event_38": "GPD LITHIUM connected",
        "event_37": "Charging Profile was changed by Genie through CANBUS",
        "lang_loading": "Language downloading...",
        "event_36": "Modify the charging curve",
        "no_more_version": "No more versions",
        "no_search_data": "No search results",
        "device_model": "Charger model",
        "event_42": "CAN switching curve",
        "event_41": "Battery failure",
        "fault_prompt": "Fault Prompt",
        "device_name": "Name",
        "event_40": "Charging schedule",
        "event_45": "OTA switching curve",
        "event_44": "OTA update curve",
        "no_more": "No more",
        "event_43": "OTA firmware update",
        "end": "End",
        "event_47": "Reverse polarity of battery",
        "select_curve": "Select Curve",
        "trips_drop_down": "Drop down search",
        "file_name": "File name",
        "start": "Start",
        "more_version": "More versions",
        "event_60": "Current gear switching 32A to 16A",
        "event_57": "Current gear switching 16A to 10A",
        "event_56": "Current gear switching 10A to 32A",
        "not_made": "You have not made an appointment",
        "event_55": "Current gear switching 10A to 16A",
        "error_4_desc": "Battery temperature too high",
        "event_59": "Current gear switching 32A to 10A",
        "event_58": "Current gear switching 16A to 32A",
        "time": "time",
        "error_0_desc": "Please check the charger",
        "tit_change_curve": "Change curve",
        "m_f": "Mains frequency",
        "trips_swiping": "To view more information, try swiping left and right~",
        "model": "Model",
        "m_v": "Mains voltage",
        "not_logged": "Please log in to your account first",
        "sign_in_succ": "Sign in successfully",
        "trips_loading": "Loading...",
        "ble_err_10001": "Bluetooth is not detected, please turn on Bluetooth and try again!",
        "ble_err_10000": "Bluetooth acquisition failed, please check if it is turned on",
        "title_lang": "Language settings",
        "error_2_desc": "Please check the AC mains voltage",
        "event": "Event",
        "btn_update": "Update",
        "calibration": "Calibration",
        "near_char": "Nearby chargers",
        "other_info": "Other Information",
        "toast_no_curve": "Curve not available",
        "event_12": "Overtime Termination",
        "event_11": "Battery low voltages",
        "event_10": "Charger Protected",
        "event_17": "Enable USB Function",
        "event_16": "Disable USB Function",
        "event_15": "Maintenance Mode",
        "event_14": "Output Current High",
        "charger_time": "Charger time",
        "event_19": "Create model",
        "event_18": "Null Current Termination",
        "date": "Date range",
        "error_6_desc": "Check and ensure the correct output battery voltage is connected",
        "error_10_desc": "Return for repair",
        "net_error": "Network error!",
        "ple_manuf": "Please enter the manufacturer name",
        "device_status": "Status",
        "trips_trylater": "Operation failed, please try again later",
        "btn_stop": "Stop",
        "error_8_desc": "Return for repair",
        "t_c_t": "Charging times record",
        "curve_num": "Curve",
        "b_p": "SOC",
        "b_t": "Temp.",
        "b_v": "Voltage",
        "calibration_time": "Calibration time",
        "make": "Set up",
        "popup_curve_change1": "Whether to change the curve from",
        "my_char": "My Chargers",
        "popup_curve_change2": "to",
        "idle": "Idle",
        "r_t": "Estimated finish time",
        "history_record": "Record",
        "charging": "Charging",
        "toolTip": "Select date",
        "current_version": "Charger firmware",
        "current_curve": "Charging Curve",
        "toast_curve_succ": "Curve modified successfully",
        "trips_3": "Charging has been scheduled, please connect AC in advance",
        "record_succ": "History record acquisition completed, Swipe to view, Streichen Sie zum Anzeigen",
        "trips_2": "The charger is connected to AC",
        "trips_1": "The battery is charging",
        "error_7_desc": "Return for repair",
        "trips_failed_connect": "Failed to automatically connect to the charger",
        "error_1_desc": "Please check whether the charger output line is connected to the battery, or check whether the connection is normal."
    },
    "drmAd": {
        "later": "Next time",
        "enable": "false",
        "line": "on the line",
        "text": "The new device management system, now with even more informative and convenient evaluation of battery data.",
        "experience": "Experience",
        "sys": "system",
        "slogan": "We have prepared a new BMS management system for you to manage a variety of industrial Internet devices with low cost and high efficiency",
        "drm": "DRM system",
        "try_later": "No, try again later"
    },
    "table1": {
        "time_calibration": "Time calibration",
        "old": "Old",
        "service_gift_time": "Service gift time",
        "low_liquid": "Low liquid level",
        "complete_sub": "Complete submission",
        "select_file": "Select File",
        "single": "Single",
        "offline": "off-line",
        "curve_update_record": "Curve update record",
        "data_service": "data service ",
        "series": "series",
        "drag_here": "Drag the file here, or click Upload",
        "repeat": "Repeat",
        "full_stop": "Full stop",
        "model": "model",
        "charger_record": "Charger record",
        "customer": "customer"
    },
    "workOrder": {
        "add_wo": "Add work order",
        "cancel": "Cancel",
        "creation_time": "Creation time",
        "FunctionalTest": "Functional testing",
        "after_sales": "After-sales analysis",
        "handler": "Handler",
        "question_category": "Question category",
        "enterAccessory": "Please enter: accessory name * quantity information",
        "formatWrong": "The format is wrong, please upload a picture or video!",
        "device_type": "Device type",
        "finish": "Finish",
        "finished_testing": "Product test",
        "repair_processing": "Repair processing",
        "all": "All",
        "SpecificDescription": "Specific description",
        "incoming": "Incoming",
        "whether_unpack": "Whether to unpack",
        "pass": "Pass",
        "warranty_expired": "Warranty expired",
        "Revise": "Revise",
        "ShipDate": "Ship date",
        "aging_test": "Aging test",
        "fail": "Fail",
        "uploadPicVideo": "You can upload pictures or videos, the file size cannot exceed 20M",
        "charger": "Charger",
        "operate": "Operate",
        "please_enter": "Please enter",
        "line_handling": "Line handling",
        "recheck": "Recheck",
        "not_performed": "Not performed",
        "no_page_view": "The current page has no access permission, please contact the administrator",
        "order_num": "Order num.",
        "client_feedback": "Client feedback",
        "return_date": "Return date",
        "quality_inspection": "Quality inspection",
        "no": "No",
        "processing_time": "Processing time",
        "other": "Other",
        "precautions": "Precautions",
        "production": "Production",
        "ImgUploadFailed": "File upload failed, please try again!",
        "production_date": "Production date",
        "save": "Save",
        "maintenance_scope": "Maintenance scope",
        "remark": "Remark",
        "inventory_date": "Inventory date",
        "submission_failed": "Submission Failed",
        "cause_analysis": "Cause analysis",
        "packaging_storage": "Packaging & storage",
        "client": "Client",
        "edit_wo": "Edit work order",
        "scrapped": "Scrapped",
        "dataNotSaved": "The data is not saved, it will be lost after clicking OK. Do you want to continue?",
        "FaultDescription": "Fault description",
        "device_sn": "Device SN",
        "question_type": "Question type",
        "yes": "Yes",
        "current_state": "Current state",
        "problem_desc": "Problem description",
        "contact_details": "Contact details",
        "DescribeDetail": "Describe the fault in detail",
        "suggest": "Suggest",
        "failed_not_processed": "Failed to submit, there are problems that have not been processed",
        "notPermission": "Failed to submit, the processor does not have permission, please contact the head of the department",
        "imgNameLen": "File name length cannot exceed 100, please try again!",
        "state_flow": "State flow",
        "successfully_saved": "Successfully saved",
        "pmc_handling": "PMC handling",
        "dev_design": "Development and Design",
        "item_not_empty": "This item cannot be empty",
        "overSize": "The file size cannot exceed 5M, please try again!",
        "VisualInspection": "Visual inspection",
        "ship_date": "Ship date"
    },
    "lvp": {
        "recover": "Recovery voltage",
        "lv1": "Level 1 low voltage warning",
        "lvp": "Low voltage protection",
        "lv3": "Level 3 low voltage warning",
        "lv2": "Level 2 low voltage warning"
    },
    "charger": {
        "under_auto": "Under autonomous control",
        "no_battery": "No battery detected",
        "app_event_8": "Firmware update completed",
        "app_event_7": "Start updating firmware",
        "version_number": "Version number",
        "app_event_9": "Start connecting Bluetooth",
        "app_event_4": "Get charging record completed",
        "app_event_3": "Start to get charging record",
        "app_event_6": "Update curve complete",
        "app_operation": "App operation record",
        "battery_high_temp": "Battery high temperature protection",
        "curve_number": "Curve number",
        "app_event_5": "Start updating curve",
        "app_event_2": "Set appointment charging",
        "app_event_1": "Charger time calibration",
        "charging_power": "Charging power",
        "interrupt_output": "Interrupt output",
        "machine_high_temp": "Machine high temperature protection",
        "mains_abnormal": "Mains abnormal",
        "model": "Model",
        "remaining": "Remaining charging time",
        "under_control": "Under control",
        "schedule_charging": "Schedule charging",
        "perform_config": "Perform configuration",
        "inquiry_record": "Inquiry record",
        "working_status": "Working status",
        "app_event_10": "Bluetooth connection completed",
        "app_event_11": "Set output voltage/output current/indicator",
        "app_event_12": "Bluetooth disconnected",
        "ble_record": "Bluetooth",
        "app_event_13": "Search Page Discovery",
        "app_event_14": "Yhub control instruction",
        "succ_modified": "Successfully modified",
        "charger_data": "Charger data",
        "submit": "Submit",
        "Internal_failure": "Internal failure of the machine",
        "curve_not_available": "The curve is not available!",
        "error_mess": "Error message",
        "output_voltage": "Output voltage",
        "content": "Content",
        "offline": "Offline",
        "supply_voltage": "Supply voltage",
        "update_time": "Update time",
        "bulk_stage": "BULK Stage",
        "finish_stage": "Finish Stage",
        "high_voltage_output": "High voltage detected at the output",
        "network_status": "Network status",
        "end_charging": "End Charging",
        "output_current": "Output current",
        "select_curve": "Select curve",
        "absorption_stage": "Absorption Stage",
        "normal": "Normal",
        "charger_temp": "Charger temperature",
        "lock_command": "Lock command",
        "mains_frequency": "Mains frequency",
        "address_error": "Address declaration error",
        "modify_curve": "Modify curve",
        "online": "Online",
        "battery_temp": "Battery temperature",
        "charging_stage": "Charging stage",
        "unable_output": "Unable to start output (no AC input)"
    }
}